import React from 'react'
import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import orgLogoStyles from './orgLogo.styles'
import DefaultOrgIcon from '../../assets/icons/DefaultOrgIcon'
import redirectToHomeHelper from '../../utils/helpers/redirectToHomeHelper'
import useHistoryPush from '../../hooks/useHistoryPush'

const OrgLogo = ({ singleOrgLogo, myOrgs }) => {
  const { redirect } = useHistoryPush()
  const useStyles = makeStyles(orgLogoStyles)
  const classes = useStyles()

  const handleOnClick = () => {
    redirectToHomeHelper([], redirect)
  }

  if (!myOrgs || !myOrgs.length) return null

  return singleOrgLogo ? (
    <img src={singleOrgLogo} alt='avatar' className={classes.logoSmall} onClick={handleOnClick} />
  ) : (
    <DefaultOrgIcon onClick={handleOnClick} className={classes.orgIcon} />
  )
}

OrgLogo.propTypes = {
  singleOrgLogo: PropTypes.string,
  myOrgs: PropTypes.array,
}

export default OrgLogo
